import { showDialogWithData } from "../../../redux/guest-slices/other.slice"
import TablePagination from "../../../components/common/PaginationSkell"
import { retrieveAllFaqs } from "../../../redux/admin-slices/faqs.slice"
import EntriesSelect from "../../../components/ui/EntriesSelect"
import InputFieldA from "../../../components/ui/InputFieldA"
import { NavLink, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { DELETE_FAQ } from "../../../utils/keywords"
import { debounce } from "../../../utils/helper"
import Icons from "../../../assets/js/Icons"
import { useEffect, useRef } from "react"
import { useState } from "react"

import {
  Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button,
  Container, Divider, Grid2 as Grid, Icon, Skeleton, Stack, Typography
} from "@mui/material"

function AllFaqs() {
  const searchRef = useRef("")
  const entriesRef = useRef("")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [data, setData] = useState({})
  const [expended, setExpended] = useState(0)
  const { refresh, loadings } = useSelector(state => state.otherSlice)

  // Handle faq expend
  const handleExpend = (index) => { setExpended(index) }

  // Handle retrieve all FAQs
  const handleRetrieveAll = (filters) => {
    dispatch(retrieveAllFaqs({
      search: searchRef?.current?.value || null,
      limit: entriesRef?.current?.value || null,
      currentPage: filters?.currentPage || null,
    })
    ).unwrap().then((data) => {
      setData(data)
    }).catch(() => { })
  }

  // Handle delete FAQs
  const handleDelete = (faqId) => {
    dispatch(showDialogWithData({
      data: { faqId },
      type: DELETE_FAQ,
    }))
  }

  // Handle search FAQs
  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  useEffect(() => {
    handleRetrieveAll()

    // eslint-disable-next-line
  }, [refresh])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">FAQs</Typography>
        <Button
          to="/faqs/add"
          variant="outlined"
          LinkComponent={NavLink}
          startIcon={<Icons.PlusSolid />}
        >Add New FAQs
        </Button>
      </Box>

      <Grid container spacing={1} className="filters-grid" justifyContent="space-between">
        <Grid size={{ xs: 12, sm: 8, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
            placeholder="Search with names"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
      </Grid>

      <Box className="page-content">
        <Stack spacing={3} mb={3}>
          {loadings?.retrieveAll ?
            new Array(5).fill().map((_, i) => (
              <Grid key={i} container spacing={2}>
                <Grid size={{ xs: 12, xl: 9 }}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Skeleton
                      sx={{
                        height: "38px",
                        width: "100%",
                        transform: "none"
                      }}
                    />
                    <Divider
                      flexItem
                      orientation="vertical"
                      sx={{ display: { xs: "none", xl: "block" } }}
                    />
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, xl: 3 }}>
                  <Stack direction="row" spacing={2}>
                    <Skeleton
                      sx={{
                        height: "38px",
                        width: "120px",
                        transform: "none"
                      }}
                    /> <Skeleton
                      sx={{
                        height: "38px",
                        width: "120px",
                        transform: "none"
                      }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            )) :
            data?.records?.length > 0 ?
              data?.records?.map((faq, i) => (
                <Grid key={faq?._id} container spacing={2}>
                  <Grid size={{ xs: 12, xl: 9 }}>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Accordion
                        variant="faqListing"
                        expanded={expended === i}
                        onChange={() => { handleExpend(i) }}
                      >
                        <AccordionSummary
                          sx={{
                            fontSize: "16px",
                            fontWeight: "500",
                            fontFamily: "Poppins",
                            minHeight: "auto !important",
                            ".MuiAccordionSummary-content": { my: "8px !important" }
                          }}
                          expandIcon={
                            <Icon sx={{ fontSize: "20px" }}>
                              <Icons.ArrowDownSharp />
                            </Icon>
                          }
                        >{faq?.question}
                        </AccordionSummary>
                        <AccordionDetails sx={{ fontWeight: "400" }}>
                          <Typography
                            fontSize={14}
                            variant="body2"
                          >{faq?.answer}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Divider
                        flexItem
                        orientation="vertical"
                        sx={{ display: { xs: "none", xl: "block" } }}
                      />
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12, xl: 3 }}>
                    <Stack direction="row" spacing={2}>
                      <Button
                        variant="outlined"
                        startIcon={<Icons.EditStroke />}
                        onClick={() => { navigate(`/faqs/edit/${faq?._id}`) }}
                      >Edit
                      </Button>
                      <Button
                        variant="outlined"
                        startIcon={<Icons.DeleteStroke />}
                        onClick={() => { handleDelete(faq?._id) }}
                      >Delete
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              )) :
              <Alert
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  borderWidth: "2px",
                  fontFamily: "Poppins",
                }}
                severity="info"
                color="primary"
                variant="outlined"
              >No data found!
              </Alert>
          }
        </Stack>

        <TablePagination
          cb={handleRetrieveAll}
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
        />
      </Box>
    </Container>
  )
}

export default AllFaqs